// import { colaboradoresGet } from "#api/colaboradores"
import ColaboradoresTabla from "#colaborador/pages/ColaboradoresTabla"
import CircularSkeleton from "#common/skeleton/CircularSkeleton"
import PERMISOS from "#constants/perfiles"
import ErrorResponse from "#core/pages/ErrorResponse"
import { useApi } from "#hooks/useApi"
import { UseHasPermission } from "#hooks/useHasPermission"
import MyTeamBulkCreation from "#performance-evaluation/components/MyTeam/MyTeamBulkCreation"
import { MyTeamColaborador } from "#performance-evaluation/components/MyTeam/MyTeamColaborador"
import MyTeamFinished from "#performance-evaluation/components/MyTeam/MyTeamFinished"
import { Box, Button } from "@mui/material"
import { ChangeTitle } from "Components/menu/funciones"
import { colaboradoresGet } from "modules/colaborador/services/api"
import { Fragment, useMemo, useState } from "react"
import { useNavigate } from "react-router-dom"

export default function MyTeam() {
	let navigate = useNavigate()
	ChangeTitle("Evaluación de Desempeño")
	const [myCollaborator, setMyCollaborator] = useState(true)
	const isRH = UseHasPermission(PERMISOS.RH)
	const params = useMemo(() => {
		const baseParams = {
			fields: [
				"sucursal_name",
				"departamento_name",
				"perfil_puesto_name",
				"photo",
				"no_empleado",
			],
			my_collaborator: true,
		}
		return baseParams
	}, [])

	const { data, loading, error } = useApi(colaboradoresGet, {
		params,
		autoFetch: true,
	})
	const collaborators = useMemo(() => data?.data || [], [data])

	if (loading) return <CircularSkeleton />
	if (error) return <ErrorResponse api={error} />

	const collaboratorsItems = collaborators.map((colaborador) => (
		<MyTeamColaborador
			key={colaborador.id}
			colaborador={colaborador}
			onClick={() =>
				navigate(`../performance_evaluation/my_evaluations/${colaborador.id}`)
			}
		/>
	))
	let NoItems = null
	if (collaboratorsItems.length === 0) {
		NoItems = (
			<Box
				sx={{
					textAlign: "center",
					fontSize: "1.2rem",
					fontWeight: "500",
					marginTop: "2rem",
				}}
			>
				No se encontraron colaboradores asignados.
			</Box>
		)
	}

	return (
		<Box display="flex" flexDirection="column" gap={1}>
			{myCollaborator ? (
				<Fragment>
					<Box
						display="flex"
						flexDirection="column"
						gap={1}
						width={"100%"}
						sx={{
							alignItems: "center",
						}}
					>
						{isRH && (
							<Button
								variant="contained"
								onClick={() => setMyCollaborator(!myCollaborator)}
							>
								{"Ver todos los colaboradores"}
							</Button>
						)}
					</Box>
					{collaboratorsItems}
					{NoItems}
				</Fragment>
			) : (
				<TablaColaboradores />
			)}
		</Box>
	)
}

const TablaColaboradores = () => {
	const params = useMemo(() => ({ activos: true, mis_colaboradores: true }), [])
	const [openFinished, setOpenFinished] = useState(false)
	const [openBulkCreation, setOpenBulkCreation] = useState(false)

	let navigate = useNavigate()
	return (
		<Box>
			<Box display="flex" justifyContent="flex-end" mb={2} gap={1}>
				<Button onClick={() => setOpenBulkCreation(true)}>
					Crear evaluacion a todos
				</Button>
				<Button onClick={() => setOpenFinished(true)}>
					Finalizar todas las evaluaciones
				</Button>
			</Box>

			<ColaboradoresTabla
				{...{
					params,
					filter: true,
					download: false,
					print: false,
					onClick: (colaborador) => {
						navigate(`../performance_evaluation/my_evaluations/${colaborador.id}`)
					},
				}}
			/>
			<MyTeamFinished open={openFinished} setOpen={setOpenFinished} />
			<MyTeamBulkCreation open={openBulkCreation} setOpen={setOpenBulkCreation} />
		</Box>
	)
}
